import React, { Component } from "react";
import Select from "react-select";

// custom styles
const customStyles = {
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? "white" : "black"
  }),
  // Render the menu in a body-level portal so it is never clipped by an
  // overflow/scroll container (e.g. inside a modal) and floats above it.
  menuPortal: (base) => ({ ...base, zIndex: 99999 })
};

class SelectDropDown extends Component {
  state = {
    selectedOption: null,
    isClearable: true,
    isSearchable: true,
    isDisabled :false
  };
  handleChange = selectedOption => {
    const isMulti = this.props.isMulti;

    // In multi-select mode react-select passes an array of options (or null when
    // fully cleared); expose the value to callers as an array of option values.
    const payloadValue = isMulti
      ? (selectedOption ? selectedOption.map(o => o.value) : [])
      : (selectedOption != undefined ? selectedOption.value : undefined);

    // Single-select still skips the callback on clear (selectedOption == undefined);
    // multi-select always fires so callers can react to an emptied selection.
    const shouldNotify = this.props.handleChange != undefined && (isMulti || selectedOption != undefined);

    if (this.props.index != undefined) {
      if (shouldNotify)
        this.props.handleChange(
          this.props.index,
          this.props.name,
          payloadValue,
          selectedOption
        );

      this.setState({ selectedOption }, () =>
        console.log(`Option selected:`, this.state.selectedOption)
      );
    }
    else {
      if (shouldNotify)
        this.props.handleChange(
          this.props.name,
          payloadValue,
          selectedOption
        );

      this.setState({ selectedOption }, () =>
        console.log(`Option selected:`, this.state.selectedOption)
      );
    }

  };

  // componentWillReceiveProps(nextProps) {
  //   console.log("componentWillReceiveProps", nextProps, this.props);
  //   if (nextProps.defaultValue != undefined) {
  //     if (nextProps.defaultValue !== this.props.value) {
  //       const option = this.props.options.find(
  //         op => op.id == nextProps.defaultValue
  //       );

  //       this.setState({ selectedOption: option });
  //     }
  //   }
  // }

  static getDerivedStateFromProps(props, state) {
    // console.log("getDerivedStateFromProps", props, state);

    // Multi-select is fully controlled through the `stateData` prop; the
    // single-value defaultValue syncing below does not apply.
    if (props.isMulti) {
      return null;
    }

    if (state.selectedOption == null) {
      const option = props.options.find(op => op.id == props.defaultValue);

      // console.log("selected", option);
      return {
        selectedOption: option
      };
    } else if (props.defaultValue !== state.selectedOption.value) {
      const option = props.options.find(op => op.id == props.defaultValue);

      return {
        selectedOption: option
      };
    }

    // Return null to indicate no change to state.
    return null;
  }

  render() {
    const { selectedOption, isClearable, isSearchable } = this.state;

    const clearableValue = this.props.isClearable !== undefined ? this.props.isClearable : isClearable;
    return (
      <Select
        maxMenuHeight={200}
        menuPortalTarget={typeof document !== "undefined" ? document.body : undefined}
        menuPosition="fixed"
        name={() => {
          if (this.props.name != undefined) return this.props.name;
          else return this.props.placeholderName;
        }}
        styles={customStyles}
        components={this.props.dropdownIndicator}
        placeholder={this.props.placeholderName}
        value={this.props.stateData}
        onChange={
          this.props.prvsexams != undefined
            ? e => this.props.onChangefunct(e, this.props.prvsexams)
            : this.handleChange
        }
        //onChange={this.handleChange}
        options={this.props.options}
        isMulti={this.props.isMulti}
        closeMenuOnSelect={this.props.isMulti ? false : true}
        hideSelectedOptions={this.props.isMulti ? false : undefined}
        isClearable={clearableValue}
        isSearchable={isSearchable}
        isDisabled={this.props.isDisabled}
        defaultValue={this.props.defaultValue}
      />
    );
  }
}

export default SelectDropDown;
